module.exports = __webpack_public_path__ + "6e0fd7f0da593037d1ea0e5a0d03edcb.svg";